var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2574 8.62865C14.5393 8.43852 14.8323 8.26498 15.1339 8.12189C14.7583 10.9807 15.4232 13.9337 17.0729 16.3793C18.7225 18.825 21.2113 20.5478 24.0027 21.2704C23.757 21.4964 23.4864 21.7031 23.2045 21.8932C19.5484 24.3593 14.5647 23.3905 12.0986 19.7345C9.6326 16.0784 10.6013 11.0947 14.2574 8.62865ZM13.139 6.97057C8.56272 10.0573 7.35382 16.2766 10.4406 20.8529C13.5273 25.4292 19.7466 26.6381 24.3229 23.5513C25.8317 22.5336 26.9698 21.1629 27.7131 19.6362C24.2669 19.8739 20.8 18.3284 18.7309 15.2609C16.6619 12.1935 16.5277 8.40003 18.0391 5.29381C16.3451 5.41114 14.6479 5.95284 13.139 6.97057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_4382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 13.4209) rotate(-34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightIcon);
export default __webpack_public_path__ + "static/media/nightIcon.4f6f7878d5d0af3de6f4f6cdf346879b.svg";
export { ForwardRef as ReactComponent };